import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['fileInput'];

  connect() {
    this.fileInputTarget.addEventListener(
      'change',
      this.submitProfileImageChange.bind(this)
    );
  }

  trimWhitespace(event) {
    event.target.value = event.target.value.trim();
  }

  uploadProfileImage(event) {
    event.preventDefault();
    this.fileInputTarget.click();
  }

  submitProfileImageChange(event) {
    event.preventDefault();
    this.fileInputTarget.parentNode.submit();
  }
}
